import React from 'react';
import { Navigate, Route, Routes } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import Layout from "../components/Layout/Layout";
import Sub from "../components/Sub/Sub";
import Home from "../containers/Home/Home";
import Success from "../containers/Success/Success";

const OpenRoute = () => {
    return ( 
          <> 
            <ToastContainer theme="light" position="top-right" autoClose={3000} />   
            <CookiesProvider>
            <Layout>
                <Routes>                  
                  <Route path="/login" element={<Sub />} />
                  <Route path="/register" element={<Sub />} />
                  <Route path="/welcome" element={ <Home />} />   
                  <Route path="/success" element={ <Success />} />                
                  <Route path="/home" element={<Home />} />
                  <Route path="/" element={<Home />} />
                  <Route path="*" element={<Navigate to="/login" />} />
                </Routes>
            </Layout>
            </CookiesProvider>
      </> 
    )
   

};

export default OpenRoute;